module.exports = __webpack_public_path__ + "static/media/fenetre-slim.be4b9fb6.png";